import { Card, Checkbox, DatePicker, Form, Input, Select } from "antd";
import React, { useEffect, useState } from "react";
import {
  updateDoc,
  doc,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db, auth } from "../../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";

import FormAction from "../../../../components/common/FormAction";
import { managementCompanies } from "../../../../utils/property";
import { toast } from "react-hot-toast";

function TenantProvidedInsurance({ data }) {
  const [checked, setChecked] = useState(false);
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));
      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const onCancel = () => {
    setChecked(false);
  };

  const handleFormSubmit = (values) => {
    Object.keys(values).forEach((field) => {
      if (values[field] === undefined) {
        values[field] = "";
      }
    });
    const status = {
      tenantProvideInsurance: {
        companyName: values.companyName,
        policyNumber: values.policyNumber,
        policyStartDate: values.policyStartDate
          ? values.policyStartDate.format("YYYY-MM-DD")
          : data?.tenantProvideInsurance?.policyStartDate,
        policyExpirationDate: values.policyExpirationDate
          ? values.policyExpirationDate.format("YYYY-MM-DD")
          : data?.tenantProvideInsurance?.policyExpirationDate,
        applyToAllTenants: values.applyToAllTenants,
      },
    };
    try {
      const tenantRef = doc(db, "companies", companyName, "tenants", data?.id);
      updateDoc(tenantRef, status);
      setChecked(false);
      toast.success("Tenant Provide Insurance updated successfully");
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    toast.error("There are problems with one or more required fields");
    console.log("Failed:", errorInfo);
  };

  const initialValues = {
    companyName: data?.tenantStatus?.companyName,
    policyNumber: data?.tenantStatus?.policyNumber,
    applyToAllTenants: data?.tenantStatus?.applyToAllTenants,
  };
  return (
    <Card
      title="Tenant Provided Insurance"
      extra={
        !checked ? (
          <span className="onclick-text" onClick={() => setChecked(true)}>
            Edit
          </span>
        ) : null
      }
    >
      {checked ? (
        <Form
          colon={false}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 11 }}
          labelWrap={{ span: 8 }}
          initialValues={initialValues}
          onFinish={handleFormSubmit}
          onFinishFailed={onFinishFailed}
        >
          <p className="onclick-text">
            I'd rather upload an insurance document to be processed
          </p>
          <Form.Item
            label="Company Name"
            required
            rules={[{ required: true, message: "Please enter company name" }]}
            name="companyName"
          >
            <Select options={managementCompanies} placeholder="Select..." />
          </Form.Item>
          <Form.Item label="Policy Number" name="policyNumber">
            <Input />
          </Form.Item>
          <Form.Item
            label="Policy Start Date"
            required
            name="policyStartDate"
            rules={[
              { required: true, message: "Please enter policy start date" },
            ]}
          >
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            label="Policy Expiration Date"
            required
            name="policyExpirationDate"
            rules={[
              {
                required: true,
                message: "Please enter policy expiration date",
              },
            ]}
          >
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item label=" " name="applyToAllTenants" valuePropName="checked">
            <Checkbox>apply to all tenants</Checkbox>
          </Form.Item>
          <FormAction cancel={onCancel} submit="submit" />
        </Form>
      ) : (
        <p style={{ textAlign: "center" }}>
          There is no renters insurance policy for this tenant.{" "}
          <span className="onclick-text">Upload an insurance policy.</span>
        </p>
      )}
    </Card>
  );
}

export default TenantProvidedInsurance;
